import * as actions from "./actionsTypes";

const initialData = {
  loaderReasonsForAbsence: false,
  reasonsForAbsence: null,
  reasonsForAbsenceFail: null,
  saveLoaderReasonsForAbsence: false,
  reasonsForAbsenceFormError: null,
};

export default function ReasonsForAbsenceReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_REASONS_FOR_ABSENCE:
      return { ...state, loaderReasonsForAbsence: action.payload };

    case actions.GET_REASONS_FOR_ABSENCE:
      return { ...state, reasonsForAbsence: action.payload };

    case actions.REASONS_FOR_ABSENCE_FAIL:
      return { ...state, reasonsForAbsenceFail: action.payload };

    case actions.SAVE_LOADER_REASONS_FOR_ABSENCE:
      return { ...state, saveLoaderReasonsForAbsence: action.payload };

    case actions.FORM_REASONS_FOR_ABSENCE_FAIL:
      return { ...state, reasonsForAbsenceFormError: action.payload };

    default:
      return state;
  }
}
